// @flow

import React from "react";
import { localize } from "redux-i18n";
import { SimpleGrid, WistiaPlayer } from "@components";

type Props = PropsFromLocalize;

class HelpPanelDashboard extends React.Component<Props> {
  get headlineData() {
    return [
      {
        id: "open-absences",
        label: this.props.t("OPEN_ABSENCES"),
        details: this.props.t("DASHBOARD_OPEN_ABSENCES_DESCRIPTION"),
      },
      {
        id: "staff-absent",
        label: this.props.t("STAFF_ABSENT_PERCENTAGE"),
        details: this.props.t("DASHBOARD_STAFF_ABSENT_DESCRIPTION"),
      },
      {
        id: "outstanding-tasks",
        label: this.props.t("OUTSTANDING_TASKS"),
        details: this.props.t("DASHBOARD_OUTSTANDING_TASKS_DESCRIPTION"),
      },
      {
        id: "recent-alerts",
        label: this.props.t("RECENT_ALERTS"),
        details: this.props.t("DASHBOARD_RECENT_ALERTS_DESCRIPTION"),
      },
      {
        id: "recent-notifications",
        label: this.props.t("RECENT_NOTIFICATIONS"),
        details: this.props.t("DASHBOARD_RECENT_NOTIFICATIONS_DESCRIPTION"),
      },
    ];
  }

  get dayTrendData() {
    return [
      {
        id: "st-absences",
        label: this.props.t("SHORT_TERM"),
        details: this.props.t("DASHBOARD_ST_ABSENCES_DESCRIPTION", {
          st: <span className="font-weight-bold text-lowercase">{this.props.t("SHORT_TERM")}</span>,
        }),
      },
      {
        id: "lt-absent",
        label: this.props.t("LONG_TERM"),
        details: this.props.t("DASHBOARD_LT_ABSENCES_DESCRIPTION", {
          lt: <span className="font-weight-bold text-lowercase">{this.props.t("LONG_TERM")}</span>,
        }),
      },
      {
        id: "total-absences",
        label: this.props.t("TOTAL_ABSENCES_NUMBER"),
        details: this.props.t("DASHBOARD_TOTAL_ST_LT_ABSENCES_DESCRIPTION"),
      },
      {
        id: "absence-percentage",
        label: this.props.t("STAFF_ABSENT_PERCENTAGE"),
        details: this.props.t("DASHBOARD_EMPLOYEES_ABSENCT_DESCRIPTION"),
      },
    ];
  }

  get departmentData() {
    return [
      {
        id: "department",
        label: this.props.t("DEPARTMENT"),
        details: this.props.t("DASHBOARD_DEPARTMENT_DESCRIPTION"),
      },
      {
        id: "total-absences",
        label: this.props.t("OPEN_ABSENCES"),
        details: this.props.t("DEPARTMENT_TOTAL_ABSENCES_DESCRIPTION"),
      },
      {
        id: "st-absences",
        label: this.props.t("SHORT_TERM"),
        details: this.props.t("DEPARTMENT_ST_ABSENCES_DESCRIPTION", {
          st: <span className="font-weight-bold text-lowercase">{this.props.t("SHORT_TERM")}</span>,
        }),
      },
      {
        id: "lt-percentage",
        label: this.props.t("LONG_TERM"),
        details: this.props.t("DEPARTMENT_LT_ABSENCES_DESCRIPTION", {
          lt: <span className="font-weight-bold text-lowercase">{this.props.t("LONG_TERM")}</span>,
        }),
      },
      {
        id: "absence-percentage",
        label: this.props.t("EMPL_ABS_PERCENTAGE"),
        details: this.props.t("DEPARTMENT_EMPLOYEES_ABSENCE_DESCRIPTION"),
      },
      {
        id: "rtw-interviews",
        label: this.props.t("PENDING_TASKS"),
        details: this.props.t("DEPARTMENT_RTW_DESCRIPTION"),
      },
    ];
  }

  get reasonData() {
    return [
      {
        id: "department",
        label: this.props.t("ABSENCE_REASON"),
        details: this.props.t("DASHBOARD_ABSENCE_REASON_DESCRIPTION"),
      },
      {
        id: "total-absences",
        label: this.props.t("OPEN_ABSENCES"),
        details: this.props.t("REASON_TOTAL_ABSENCES_DESCRIPTION"),
      },
      {
        id: "available-today",
        label: this.props.t("PERCENTAGE_OF_TOTAL"),
        details: this.props.t("REASON_TOTAL_ABSENCES_PERCENTAGE_DESCRIPTION"),
      },
      {
        id: "st-absences",
        label: this.props.t("SHORT_TERM"),
        details: this.props.t("REASON_ST_ABSENCES_DESCRIPTION", {
          st: <span className="font-weight-bold text-lowercase">{this.props.t("SHORT_TERM")}</span>,
        }),
      },
      {
        id: "lt-percentage",
        label: this.props.t("LONG_TERM"),
        details: this.props.t("REASON_LT_ABSENCES_DESCRIPTION", {
          lt: <span className="font-weight-bold text-lowercase">{this.props.t("LONG_TERM")}</span>,
        }),
      },
      {
        id: "available-tomorrow",
        label: this.props.t("EST_AVRG_LEN_ABS"),
        details: this.props.t("REASON_ESTIMATED_AVERAGE_DESCRIPTION"),
      },
      {
        id: "rtw-interviews",
        label: this.props.t("EST_TOTAL_DAYS_LOST_FOR_ABS"),
        details: this.props.t("REASON_ESTIMATED_TOTAL_DAYS_DESCRIPTION"),
      },
    ];
  }

  get columns() {
    return [
      {
        title: this.props.t("ITEM"),
        name: "setting",
        width: 110,
        renderItem: item => item.label,
      },
      {
        title: this.props.t("DESCRIPTION"),
        name: "details",
        renderItem: item => item.details,
      },
    ];
  }

  render() {
    return (
      <div>
        <p className="fs-14">{this.props.t("DASHBOARD_HELP_INTRODUCTION")}</p>
        <h6 className="font-weight-bold">{this.props.t("TUTORIAL")}</h6>
        <div className="mb-3">
          <WistiaPlayer
            videoId={WistiaPlayer.videos.DASHBOARD_INSTRUCTIONS}
            title={this.props.t("DASHBOARD_INSTRUCTIONS")}
          />
        </div>
        <h6 className="font-weight-bold">{this.props.t("HEADLINES")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.headlineData} />
        <h6 className="font-weight-bold">{this.props.t("DAY_TREND")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.dayTrendData} />
        <h6 className="font-weight-bold">{this.props.t("OPEN_ABSENCES_BY_DEPARTMENT")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.departmentData} />
        <h6 className="font-weight-bold">{this.props.t("OPEN_ABSENCES_BY_REASON")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.reasonData} />
      </div>
    );
  }
}

export default localize()(HelpPanelDashboard);
